import { Page } from '@react-pdf/renderer'
import { ReactElement, ReactNode } from 'react'

import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfPageProps {
  children: ReactNode
}

export const SalesReportPdfPage = ({ children }: SalesReportPdfPageProps): ReactElement => {
  return (
    <Page size="A4" style={pdfStyles.page} wrap>
      {children}
    </Page>
  )
}
